<template>
  <main class="w-full">
    <Header />

    <div class="bg-gray-100">
      <section
        class="cover bg-blue-teal-gradient relative bg-blue-500 px-4 sm:px-8 lg:px-16 xl:px-40 2xl:px-64 overflow-hidden py-16 flex items-center"
      />
    </div>

    <section class="relative px-4 py-16 sm:px-8 lg:px-16 xl:px-40 2xl:px-64">
      <div class="flex flex-col lg:flex-row lg:-mx-8">
        <div class="w-full lg:w-2/3 mx-auto lg:px-8">
          <slot />
        </div>
      </div>
    </section>

    <Footer />
  </main>
</template>

<script>
import Footer from "@/Pages/Home/Shared/Footer.vue";
import Header from "@/Pages/Home/Shared/Header.vue";

export default {
  components: {
    Header,
    Footer,
  },
  props: {
    auth: Object,
  },
};
</script>
